import type { FC, ReactNode } from 'react';

import styles from './ModalHeader.module.scss';

interface ModalHeaderProps {
	description: ReactNode;
	title: ReactNode;
}

export const ModalHeader: FC<ModalHeaderProps> = ({ description, title }) => {
	return (
		<div className={styles.header}>
			<h1 className={styles.title}>{title}</h1>
			<h5 className={styles.description}>{description}</h5>
		</div>
	);
};
